<template>
  <div>
    <Mainlayout></Mainlayout>
    <div class="p-3 bg-light min-vh-100 mb-5">
      <!-- Header -->
      <div class="d-flex align-items-center mb-3 mt-5">
        <CButton color="light" class="me-2" @click="$router.go(-1)">
          <img src="../assets/img/Arrow2.png" width="20px" />
        </CButton>
        <h5 class="mb-0 fw-bold">Customer Informations</h5>
      </div>
      <!-- Subheader -->
      <div class="text-muted small mb-3">
        Manage and view your customer details
      </div>
      <!-- Search -->
      <b-input-group class="mb-3">
        <b-form-input v-model="search" placeholder="Search customers..."></b-form-input>
        <b-input-group-append>
          <b-button variant="outline-secondary">
            <i class="fas fa-search"></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <!-- Customer Cards -->
      <div v-for="customer in filteredCustomers" :key="customer.email" class="customer-card mb-3 p-3 bg-white rounded shadow-sm">
        <div class="d-flex align-items-center">
          <div class="avatar bg-light rounded-circle text-primary d-flex align-items-center justify-content-center me-3" style="width:40px; height:40px;">
            <i class="fas fa-user"></i>
          </div>
          <div class="ml-2">
            <h6 class="mb-1 fw-bold">{{ customer.name }}</h6>
            <div class="text-muted small">
              <div><i class="fas fa-envelope me-1"></i>{{ customer.email }}</div>
              <div><i class="fas fa-phone me-1"></i>{{ customer.phone }}</div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3 pt-2 border-top">
          <div>
            <small class="text-muted">Points Collected</small>
            <div class="fw-bold text-success" style="
    border-radius: 8px;
    border: 1.275px solid #B9F8CF;
    background: #F0FDF4;
    color: #008236;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    padding:3px;
    line-height: 16px;text-align: center;">{{ customer.collected.toLocaleString() }}</div>
          </div>
          <div>
            <small class="text-muted">Points Redeemed</small>
            <div class="fw-bold text-primary" style="
            border-radius: 8px;
border: 1.275px solid #BEDBFF;
background: #EFF6FF;color: #1447E6;
font-family: Inter;
font-size: 12px;
font-style: normal;
font-weight: 500;
padding:3px;
line-height: 16px;text-align: center;">{{ customer.redeemed.toLocaleString() }}</div>
          </div>
        </div>
      </div>
    </div>
    <Footerlayout class="d-md-none d-lg-none"></Footerlayout>
  </div>
</template>
  
<script>
  import Mainlayout from "../containers/AllHeader.vue";
  import Footerlayout from "../containers/TheBottomCustom.vue";
  export default {
    name: "CustomerInformation",
    components: {
      Footerlayout,
      Mainlayout
    },
    data() {
      return {
        search: "",
        // customers: [{
        //     name: "Sarah Johnson",
        //     email: "sarah.johnson@email.com",
        //     phone: "+1 (555) 123-4567",
        //     collected: 2450,
        //     redeemed: 1200,
        //   },
        //   {
        //     name: "Michael Chen",
        //     email: "michael.chen@email.com",
        //     phone: "+1 (555) 234-5678",
        //     collected: 3820,
        //     redeemed: 2100,
        //   },
        //   {
        //     name: "Emily Rodriguez",
        //     email: "emily.rodriguez@email.com",
        //     phone: "+1 (555) 345-6789",
        //     collected: 1590,
        //     redeemed: 890,
        //   },
        //   {
        //     name: "David Kim",
        //     email: "david.kim@email.com",
        //     phone: "+1 (555) 456-7890",
        //     collected: 4200,
        //     redeemed: 3150,
        //   },
        // ],
        customers:[],
        user:{}
      };
    },
    computed: {
      filteredCustomers() {
        if (!this.search) return this.customers;
        const term = this.search.toLowerCase();
        return this.customers.filter(
          (c) =>
          c.name.toLowerCase().includes(term) ||
          c.email.toLowerCase().includes(term)
        );
      },
    },
    async mounted() {

      try {
      const isAuth = await this.UserAuth();
      if (isAuth)
      {
        this.GetInfoUser();
      await this.GetInfoUser();
        await this.GetListCustomer();
      } 
      else 
      {
        this.GoToLogin();
      }
    } catch (error) {
      this.GoToLogin?.();
      console.error("Error during authentication:", error);
    }
    
       
      
    },
    methods: {
      GoToLogin() {
      const path = this.$router.currentRoute.path;
      if (path.toLowerCase() !== "/login") {
        this.$router.push({
          path: "/Login",
          query: { targetUrl: this.$router.currentRoute.fullPath },
        });
      }
    },
      async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                } else {
                   
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                console.error("Error fetching user info:", error);
            }
        },
        async GetListCustomer() {
  try {
    const response = await this.$API.get(
      this.$GetListUserDashboardPointAndRedeem + "?companyId=" + this.user.companyId,
      { withCredentials: true }
    );

    if (response.status === 200) {
      this.customers = response.data.map(c => ({
        name: c.name,
        email: c.email,
        phone: c.phone,
        collected: c.totalPoints,  // map API to UI
        redeemed: c.totalRedeemed               // default until you implement redeem data
      }));

      console.log("customers loaded", this.customers);
    }
  } catch (error) {
    console.error("Error fetching user information:", error);
  }
}
    }
  };
</script>
  
<style scoped>
  .customer-card {
    transition: box-shadow 0.2s ease;
  }
  .customer-card:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
</style>